import BonusBuyWheelComponent from "components/bonus-wheel/bonus-wheel";
import { StopAutoplayCommand } from "slotworks/commands/autoplay/stop-autoplay";
import Layers from "slotworks/graphics/layers/layers";
import autoplayModel from "slotworks/model/autoplay-model";
import gameState from "slotworks/model/game-state";
import soundManager from "slotworks/sound/sound-manager";
import State from "slotworks/state-machine/states/state";
import Contract from "slotworks/utils/contract";
import { parallel, sequence } from "slotworks/utils/race-utils";

export default class BonusWheel extends State {

    public onEnter() {
        const bonuswheel = new BonusBuyWheelComponent();

        if (autoplayModel.stopOnFeatureWin) {
            StopAutoplayCommand();
        }
        
        bonuswheel.start().then(() => {
            if (gameState.getCurrentGame().inFreespinsGame) {
                sequence([
                    () => parallel([
                        () => Layers.Custom.get("Transition").setScene("fs"),
                        () => Contract.wrap(() => {
                            bonuswheel.exitBonus();                            
                            setTimeout(() => {
                                soundManager.customEvent("bonus_music_stop");
                                soundManager.customEvent("plaque_exit");
                            }, 900);
                        })
                    ]),
                    () => Layers.Custom.get("Transition").defaultScene(),
                ]).then(() => {
                    soundManager.customEvent("bonus_music_stop");
                    soundManager.customEvent("freespins_music");
                    this.complete();
                });
            } else {
                this.complete();
                bonuswheel.exitBonus();
            }
        })
    }

}